/*
 * form (schema)
 */
import { boolean, text, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { users } from "../user/user.schema"

export const forms = schema.table("forms", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Definition ---
	name: varchar("name", { length: 128 }).notNull(),
	slug: varchar("slug", { length: 64 }).notNull(), // e.g. "phq9", "gad7"
	description: text("description"),
	templateS3Key: varchar("template_s3_key", { length: 512 }), // fillable PDF template (populated later)

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
